__turbopack_context__.v({
  "pageMain": "home-client-module__WXRjuG__pageMain",
  "srOnly": "home-client-module__WXRjuG__srOnly",
});
